export default __webpack_public_path__ + "assets/apple-touch-icon-80x80-e844b4f.png";